import { useCustomLocale } from '@group-link-one/gl-components';
import type { IFallBackTranslations } from '../Types/translations';
import { fallBackTranslate } from '@/Branding/sonar-print/FallBack/Locale/_index';

export const useFallBackTranslate = () => {
  const { customLocale } = useCustomLocale<IFallBackTranslations>(fallBackTranslate);

  return {
    customLocale,
  };
};
